import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyFormDto, CompanyFormInterface } from '@zaoblako/shared/modules/client/dtos/company/company.form.dto';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { PersonFormInterface } from '@zaoblako/shared/modules/client/dtos/person/person-form.dto';
import { PersonTypeEnum } from '@zaoblako/shared/modules/client/enums/person.type.enum';
import type { Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { CompanyService } from '@zaoblako/web/core/services/client/company.service';
import { InnAutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/inn-auto-complete/inn-auto-complete.component';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  selector: 'crm-newsletter-welcome-system-create-company',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, ButtonComponent, InnAutoCompleteComponent],
  templateUrl: './newsletter-welcome-system-create-company.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemCreateCompanyComponent extends BaseFormComponent<CompanyFormInterface> {
  public loading = false;
  public company = <CompanyFormInterface>{};
  public persons: PersonFormInterface[] = [];
  @Input() public databases: Connection1cFindInterface[] = [];
  public person: PersonFormInterface;
  public dto = CompanyFormDto;

  @Output() public next = new EventEmitter<CompanyFindInterface>();

  public constructor(private readonly companyService: CompanyService, private readonly cdRef: ChangeDetectorRef) {
    super();
  }

  public searchParson(name: string) {
    this.companyService.externalSearch({ query: name }).subscribe((persons) => {
      this.persons = persons;
      this.cdRef.markForCheck();
    });
  }

  public selectedPerson(person: PersonFormInterface) {
    if (person) {
      if (typeof person === 'object') {
        this.company = {
          ...this.company,
          name: person.name,
          personType: person.personType,
          manager: person.manager,
          email: person.email,
          phone: person.phone,
          website: person.website,
          address: person.address,
          postAddress: person.postAddress,
          kpp: person.kpp,
          ogrn: person.ogrn,
          inn: person.inn
        };
      } else {
        this.company.inn = person;
        this.company.name = 'Моя компания';
        this.company.personType = PersonTypeEnum.LEGAL_ENTITY;
      }
      this.company.bankDetails = [];
      this.company.connection = this.databases[0];
    }
  }

  public create() {
    const { valid, errors } = this.checkValidate(this.company);
    if (!valid) {
      this.errors = errors?.validationErrors;
      console.error(this.errors);
    } else {
      this.loading = true;
      this.errors = null;
      this.cdRef.markForCheck();
      this.companyService.create<CompanyFindInterface>(this.company).subscribe({
        next: (result) => {
          this.loading = false;
          this.cdRef.markForCheck();
          this.next.emit(result);
        },
        error: () => {
          this.loading = false;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
